module.exports = __webpack_public_path__ + "img/cross-white.51a870ea.svg";